import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

// Types
import { AppDispatch } from 'reducers/index';

// Utils
import requestPromoMessage from 'actions/PromoMessageActions';
import {
  getPromoMessage,
  getPromoMessageBackgroundColor,
  getPromoMessageBusy,
  getPromoMessageLink,
  getPromoMessageLoaded,
  getPromoMessageTextColor,
} from 'selectors/PromoMessageSelectors';

// Styles
import { AnnouncementBannerWrapper, BannerText } from './AnnouncementBanner.styles';

export type AnnouncementBannerProps = {
  hideContentOnScroll?: boolean;
};

const AnnouncementBanner = ({ hideContentOnScroll }: AnnouncementBannerProps): JSX.Element => {
  const dispatch: AppDispatch = useDispatch();
  const busy = useSelector(getPromoMessageBusy);
  const link = useSelector(getPromoMessageLink);
  const message = useSelector(getPromoMessage);
  const messageLoaded = useSelector(getPromoMessageLoaded);
  const promoBackgroundColor = useSelector(getPromoMessageBackgroundColor);
  const promoTextColor = useSelector(getPromoMessageTextColor);

  useEffect(() => {
    if (!busy && !messageLoaded) {
      dispatch(requestPromoMessage()).catch(() => undefined);
    }
  }, [busy, dispatch, messageLoaded]);

  const renderBannerText = () => {
    return link ? (
      <BannerText color={promoTextColor} href={link} inline noUnderline sizes="smaller">
        <div
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </BannerText>
    ) : null;
  };

  return (
    <AnnouncementBannerWrapper
      backgroundColor={promoBackgroundColor}
      hideContentOnScroll={hideContentOnScroll}
    >
      {renderBannerText()}
    </AnnouncementBannerWrapper>
  );
};

export default AnnouncementBanner;
